import React from 'react';

import { withPrefix } from 'gatsby';
import classes from './thumbnail.module.css';

const Thumbnail = props => {
  const make = props.data;
  return (
    <div className={classes.Thumbnail}>
      <img
        height={60}
        width={60}
        src={withPrefix(`/new-logos/${make.newImagePath}`)}
        alt={`${make.make} Logo`}
      />
      <p className="truncate" style={{ margin: 0, maxWidth: '100%' }}>
        {make.make}
      </p>
    </div>
  );
};

export default Thumbnail;
